export class KitTimer {
    private tasks: { [taskName: string]: { timer: number; count: number; callback: () => void } } = {};

    // 创建定时任务
    SetTimer(taskName: string, callback: () => void, repeatCount: number = 1, delay: number = 0): void {
        if (this.tasks[taskName]) {
            console.log(`任务 ${taskName} 已存在，无法创建新的定时任务。`);
            return; // 如果任务已经存在，返回并不创建新的任务
        }

        let timer: number;
        if (repeatCount > 0) {
            let remainingCount = repeatCount;
            timer = window.setInterval(() => {
                callback();
                remainingCount--;
                if (remainingCount === 0) {
                    this.clearTask(taskName); // 完成后清除任务
                }
            }, delay * 1000);
        } else if (repeatCount === -1) {
            timer = window.setInterval(() => {
                callback();
            }, delay * 1000);
        } else { // 仅仅执行一次
            timer = window.setTimeout(() => {
                callback();
                this.clearTask(taskName); // 完成后清除任务
            }, delay * 1000);
        }

        this.tasks[taskName] = { timer, count: repeatCount, callback };
    }

    // 清除指定任务
    clearTask(taskName: string): void {
        const task = this.tasks[taskName];
        if (task) {
            if (task.timer) {
                if (task.count > 0) {
                    window.clearInterval(task.timer); // 清除间隔任务
                } else {
                    window.clearTimeout(task.timer); // 清除单次任务
                }
            }
            delete this.tasks[taskName]; // 删除任务
            console.log(`任务 ${taskName} 已清除。`);
        } else {
            console.log(`任务 ${taskName} 不存在，无法清除。`);
        }
    }
}
